<template>
  <div>
    <v-box :scrollable="true">
      <b-tabs content-class="">
        <b-tab
            :active="activeBranding"
        >
          <template #title>
            {{$tr('branding','Branding')}}
            <tab-icon :status="(!readOnlyInputs && organizationForm.canSubmit) ? 'EDITED' :
                           (!readOnlyInputs && !organizationForm.canSubmit) ? 'ERROR' : ''"></tab-icon>
          </template>
          <form-header
            :save-edit-mode="readOnlyInputs"
            :edit-enabled="organizationForm.canSubmit"
            :save-enabled="organizationForm.canSubmit && !readOnlyInputs"
            @edit="edit"
            @save="save(false)"
          ></form-header>
          <b-container>
            <b-row>
              <b-col cols="6">
                <reach-input
                    data-test-path="company-id-name"
                    :label="$tr('organizationSetupActivity.company.ID','Company ID (used on login page)')"
                    :form-field="organizationForm.name"
                    :read-only="true"
                >
                </reach-input>
              </b-col>

            </b-row>
            <b-row>
              <b-col lg="6">
                <reach-input
                    data-test-path="company-short-name"
                    :label="$tr('organizationSetupActivity.short-name','Company short name')"
                    :placeholder="$tr('organizationSetupActivity.enter-short-name','Enter short name company')"
                    :form-field="organizationForm.shortName"
                    :read-only="readOnlyInputs"
                >
                </reach-input>
              </b-col>
              <b-col lg="6">
                <reach-input
                    data-test-path="company-full-name"
                    :label="$tr('organizationSetupActivity.company-name','Company full name')"
                    :placeholder="$tr('organizationSetupActivity.enter-name','Enter full name company')"
                    :form-field="organizationForm.fullName"
                    :read-only="readOnlyInputs"
                >
                </reach-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-container>
                  <b-row>
                    <b-col>
                      <label class="form-group">{{$tr("LoginPageLogo50x50-300x300","Login page logo (50x50 - 300x300)")}}</label>
                    </b-col>
                  </b-row>
                  <b-row class="pb-3">
                    <b-col>
                      <ImageViewer
                          v-if="organizationForm.loginPageImage.value"
                          :min-height="300"
                          :max-height="300"
                          :max-width="300"
                          :src="organizationForm.loginPageImage.value.url"
                          :enable-zoom-in="true"
                          :zoom="true"
                          :remove="true"
                          :edit="true"
                          @removeImage="setLoginPageImageAsNull"
                          @zoomImage="imageLoginPageZoom"
                          @editImage="editLoginPageImage"
                          :read-only-inputs="readOnlyInputs"
                          :organization-picture="true"
                      >
                      </ImageViewer>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="p-0">
                      <FileUpload :read-only="readOnlyInputs" @file-selected="loginPageImageSelected" ref="pageLogoUpload"/>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
              <b-col lg="6" class="pt-5 pb-5 pt-lg-0 pb-lg-0">
                <b-container>
                  <b-row>
                    <b-col>
                      <label class="form-group">Navigation bar logo (25x25 - 70x40)</label>
                    </b-col>
                  </b-row>
                  <b-row class="pb-3">
                    <b-col>
                      <ImageViewer
                          v-if="organizationForm.navigationBarImage.value"
                          :min-height="300"
                          :max-height="300"
                          :max-width="300"
                          :src="organizationForm.navigationBarImage.value.url"
                          :enable-zoom-in="true"
                          :zoom="true"
                          :remove="true"
                          :edit="true"
                          @removeImage="setNavigationBarImageAsNull"
                          @editImage="editNavigationBarImage"
                          @zoomImage="imageNavigationBarZoom"
                          :read-only-inputs="readOnlyInputs"
                          :organization-picture="true"
                      >
                      </ImageViewer>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="p-0">
                      <FileUpload :read-only="readOnlyInputs" @file-selected="navigationBarImageSelected" ref="navigationBarLogoUpload"/>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-center mt-3">
                <label v-if="changedOrganizationPicture" class="text-danger" style="font-size: 17px">
                  {{$tr('organizationSetupActivity.save-changes','Save changes to keep organization picture')}}</label>
              </b-col>
            </b-row>
          </b-container>
        </b-tab>

        <b-tab
            :active="!activeBranding"
            title="Domains"
        >
          <b-container>
            <b-row class="pt-2">
              <b-col lg="6">
                <b-container>
                  <b-row>
                    <b-col>
                      <label>{{$tr('organizationSetupActivity.connect-custom','You may connect custom domain to the application.')}}</label>
                    </b-col>
                  </b-row>
                  <b-row class="pt-5">
                    <b-col class="pt-3">
                      <reach-input
                          :label="'Status: ' + statusOfVerification"
                          :placeholder="$tr('enterDomainCompany','Enter domain company')"
                          :form-field="domainForm"
                          :disabled="statusOfVerification === 'verification' || statusOfVerification === 'verified'"
                          :icon="iconStatusLabel"
                          :show-left-icon="true"
                          :read-only="readOnlyInputsSettings"
                      >
                      </reach-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="text-center">
                      <b-button
                          @click="clickOnButton"
                          :disabled="!domainForm.isValid || !domainForm.value || readOnlyInputsSettings"
                          :class="statusOfVerification === 'verification' ? 'button-long' : 'standard-button'"
                          variant="plm-action"
                      >{{ buttonStatus }}
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row class="pt-5">
                    <b-col class="pt-3">
                      <label class="text-danger" v-if="verificationError">
                        {{$tr('organizationSetupActivity.error-verification','Verification error:')}}
                        {{ verificationError }} </label>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
              <b-col lg="6">
                <b-container>
                  <b-row>
                    <b-col>
                      <label>{{$tr('organizationSetupActivity.step1','Step 1 - setup domain IP resolution.')}}
                        <br><br>
                        {{$tr('organizationSetupActivity.set-cname','Set CNAME record to topscores.io')}}
                        <br>{{$tr('or','or')}}<br>
                        {{$tr('organizationSetupActivity.setA','Set A record to 1.2.3.4')}}</label>
                    </b-col>
                  </b-row>
                  <b-row class="pt-4">
                    <b-col>
                      <label>{{$tr('organizationSetupActivity.step2','Step 2 - Setup domain verification.')}}</label>
                    </b-col>
                  </b-row>
                  <b-row class="pt-4">
                    <b-col>
                      <label>
                          {{$tr("organizationSetupActivity.sentence","Access your DNS Manager: Log in to the DNS management interface where your domain is registered. This could be with your domain registrar, a hosting provider, or a cloud service provider."+
                        "Locate DNS Settings: Find the DNS settings or DNS zone editor in the management dashboard. This is where you manage all types of DNS records for your domain, including A, MX, TXT, and CNAME records."+
                        "Find the Existing CNAME Record: Look through the list of current DNS records to find the CNAME record you want to change. It will typically be listed by its alias name, pointing to a specific canonical domain."+
                        "Edit the CNAME Record: Click on the edit button or link next to the CNAME record. You’ll need to specify the new destination domain (the domain to which the alias should now point). Ensure you follow the correct format, usually a fully qualified domain name (FQDN).")}};
                      </label>

                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </b-tab>

        <b-tab
            title="Settings"
        >
          <b-container>
            <b-row class="pt-2">
              <b-col class="text-center">
                <label style="font-weight: bold; font-size: 20px">{{$tr('organizationSetupActivity.account-deletion','Organization account deletion')}}</label>
              </b-col>
            </b-row>
            <b-row class="pt-4">
              <b-col class="text-center">
                <b-button
                    @click="deleteOrganization"
                    class="standard-button"
                    variant="plm-danger-primary"
                    :disabled="readOnlyInputsSettings"
                >Delete
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-tab>
      </b-tabs>
    </v-box>

    <FooterNavbar data-test-path="organization-footer">
      <CloseButton :read-only="readOnlyInputs" @close="close"></CloseButton>
      <save-and-close-button
          v-if="!readOnlyInputs"
          :enabled="organizationForm.canSubmit && !readOnlyInputs"
          @save="save"
      />
    </FooterNavbar>

  </div>
</template>

<script>

import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import Perms from "@/server/Perms";
import OrganizationForm from "@/components/organization/OrganizationForm";
import VBox from "@/components/VBox";
import ReachInput from "@/components/inputs/ReachInput";
import FileUpload from "@/components/FileUpload";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import ImageViewer from "@/components/img/ImageViewer";
import Domain from "@/server/com/silkplm/model/users/Domain";
import ValidatedField from "@/validation/ValidatedField";
import ValidatedForm from "@/validation/ValidatedForm";
import EventBus from "@/utils/EventBus";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import ActivityManager from "@/activity/ActivityManager";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import FormHeader from "@/components/forms/FormHeader";
import DialogManager from "@/utils/DialogManager";
import SaveAndCloseButton from "@/components/navbar/SaveAndCloseButton";
import TabIcon from "@/components/layout/TabIcon";


const PinturaImageEditor = () => require("@/components/img/PinturaImageEditor");
const SlideShow = () => require("@/components/img/SlideShow");

export default {
  name: "OrganizationSetup",
  permission: Perms.ORGANIZATION_SETTINGS,

  components: {
    TabIcon,
    SaveAndCloseButton,
    FormHeader, CloseButton, FooterButton, FooterNavbar, VBox, ReachInput, FileUpload, ImageViewer},

  async created() {

    this.$onEvent(ServerEvents.domainVerificationChanged, async (ev) => {
      this.domain = await Rpc.domain.DomainBuilder.getDomain();
      if (this.domain) {
        this.statusOfVerification = this.domain.status;
        this.domainForm.value = this.domain.name;
        this.verificationError = this.domain.verificationError;
      }
      this.setButtonAndIconLabel();
    });
  },

  async mounted() {
    this.domain = await Rpc.domain.DomainBuilder.getDomain();
    await this.organizationForm.editOrganization();
    if (this.domain) {
      this.statusOfVerification = this.domain.status;
      this.domainForm.value = this.domain.name;
      this.verificationError = this.domain.verificationError;
    }
    this.setButtonAndIconLabel();
  },

  methods: {

    ...Activity.methods,

    getTitle() {
      return "Organization setup";
    },

    cancel() {
      this.close();
    },

    async canClose(){
      return await DialogManager.canClose(!this.readOnlyInputs);
    },

    edit(){
      this.readOnlyInputs = false;
    },

    setButtonAndIconLabel() {
      if (this.statusOfVerification === "verified") {
        this.buttonStatus = "Unbind";
        this.iconStatusLabel = "check";
      } else if (this.statusOfVerification === "verification") {
        this.buttonStatus = "Cancel verification";
        this.iconStatusLabel = "spinner";
      } else if (this.statusOfVerification === "not verified") {
        this.buttonStatus = "Bind";
        this.iconStatusLabel = "question";
      }
    },

    async save(autoClose=true) {
      if (this.isLoginPageImageDeleted) {
        await this.deleteLoginPageImage();
      }
      if (this.isNavigationBarImageDeleted ) {
        await this.deleteNavigationBarImage();
      }
      await this.organizationForm.saveOrganization();
      EventBus.$emit(Events.organizationLogoChanged);
      this.readOnlyInputs = true;

      autoClose && this.cancel();
    },

    async clickOnButton() {
      if (this.statusOfVerification === "not verified") {
        await this.bindOrganization();
      } else if (this.statusOfVerification === "verification") {
        await this.cancelVerification();
      } else if (this.statusOfVerification === "verified") {
        await this.unbindOrganization();
      }
    },

    async bindOrganization() {
      this.statusOfVerification = "verification";
      this.buttonStatus = "Cancel verification";
      this.iconStatusLabel = "fa-clipboard-list-check";

      this.domain = await Rpc.domain.DomainBuilder.bindDomain(this.domainForm.value);
      this.statusOfVerification = this.domain.status;

      if (this.domain.status === "verified") {
        this.domainForm.value = this.domain.name;
        this.iconStatusLabel = "check";
        this.buttonStatus = "Unbind";
      } else if (this.domain.status === "verification") {
        this.domainForm.value = this.domain.name;
        this.iconStatusLabel = "fa-clipboard-list-check";
        this.buttonStatus = "Cancel verification";
      } else if (this.domain.status === "not verified") {
        if (!this.domain.verificationError) {
          this.domainForm.value = this.domain.name;
          this.iconStatusLabel = "question";
          this.buttonStatus = "Bind";
        } else {
          this.verificationError = this.domain.verificationError;
          this.iconStatusLabel = "frown";
          this.buttonStatus = "Bind";
        }
      }
    },

    async unbindOrganization() {
      if (await DialogManager.yesNo($tr('organizationSetupActivity.unbind','Unbind domain'),
          $tr('organizationSetupActivity.sure-unbind','Are you sure you want to unbind this domain?'))) {
        await Rpc.domain.DomainBuilder.unbindDomain(this.domain);
        this.statusOfVerification = "not verified";
        this.buttonStatus = "Bind";
        this.iconStatusLabel = "fa-atlas";
        this.verificationError = "";
        this.domainForm.value = "";
      }
    },

    async cancelVerification() {
      await Rpc.domain.DomainBuilder.unbindDomain(this.domain);
      this.buttonStatus = "Bind";
      this.iconStatusLabel = "fa-atlas";
      this.domainForm.value = "";
      this.statusOfVerification = "not verified";
    },

    async imageLoginPageZoom() {
      let slideShow = await ActivityManager.showActivity(SlideShow, {
        image: this.organizationForm.loginPageImage.value,
        singleImageEditor: true,
        uploadImage: async (image) => await Rpc.OrganizationSetup.uploadLoginPageImage(image).lock()
      });
      slideShow.$on("new-image", (image) => {
        this.organizationForm.loginPageImage.value = image;
        this.changedOrganizationPicture = true;
      });
    },

    async imageNavigationBarZoom() {
      let slideShow = await ActivityManager.showActivity(SlideShow, {
        image: this.organizationForm.navigationBarImage.value,
        singleImageEditor: true,
        uploadImage: async (image) => await Rpc.OrganizationSetup.uploadNavigationBarImage(image).lock()
      });
      slideShow.$on("new-image", (image) => {
        this.organizationForm.navigationBarImage.value = image;
        this.changedOrganizationPicture = true;
      });
    },

    async editLoginPageImage(){
      let result = await (await ActivityManager.showActivity(PinturaImageEditor, {
        image: this.organizationForm.loginPageImage.value,
        singleImageEditor: true,
        uploadImage: async (image) => await Rpc.OrganizationSetup.uploadLoginPageImage(image).lock()
      })).getResult();

      if (result) {
        this.organizationForm.loginPageImage.value = result.newFile;
        this.changedOrganizationPicture = true;
      }
    },

    async editNavigationBarImage(){
      let result = await (await ActivityManager.showActivity(PinturaImageEditor, {
        image: this.organizationForm.navigationBarImage.value,
        singleImageEditor: true,
        uploadImage: async (image) => await Rpc.OrganizationSetup.uploadNavigationBarImage(image).lock()
      })).getResult();

      if (result) {
        this.organizationForm.navigationBarImage.value = result.newFile;
        this.changedOrganizationPicture = true;
      }
    },

    async imageSelected(avatarUpload) {
      let file = avatarUpload.getFile();
      avatarUpload.setProgress(0);

      try {
        if (avatarUpload === this.$refs.pageLogoUpload) {
          let fileToken = await Rpc.OrganizationSetup.uploadLoginPageImage(file).lock().onProgress((e) => {
            avatarUpload.setProgress(e.percent);
          });
          this.organizationForm.loginPageImage.value = fileToken;
        } else if (avatarUpload === this.$refs.navigationBarLogoUpload) {
          let fileToken = await Rpc.OrganizationSetup.uploadNavigationBarImage(file).lock().onProgress((e) => {
            avatarUpload.setProgress(e.percent);
          });
          this.organizationForm.navigationBarImage.value = fileToken;
        }
        avatarUpload.reset();
      } catch (e) {
        if (e instanceof RpcInputValidationException) {
          avatarUpload.setError(e.fields.image.errorMessage);
        }
      }
    },

    async deleteOrganization() {
      let message = await DialogManager.textarea($tr('organizationSetupActivity.deleting-account',"Deleting organization account"),
          $tr('organizationSetupActivity.sure-delete',"Are you sure you want to delete your organization account? ") +
          $tr('organizationSetupActivity.why-delete',"Deleting an organization's account is irreversible and involves deleting all data. Why do you want to delete your account?"), true);
      if (message) {
        if (await DialogManager.yesNo($tr('organizationSetupActivity.deleting-account',"Deleting organization account"),
            $tr('organizationSetupActivity.sure-delete','Are you sure you want to delete your organization account? ') +
            $tr('organizationSetupActivity.info','Deleting an organization\'s account is irreversible and involves deleting all data.'), true)) {
          await Rpc.OrganizationSetup.deleteMyOrganization(message);
        }
      }
    },

    async loginPageImageSelected() {
      let avatarUpload = this.$refs.pageLogoUpload;
      await this.imageSelected(avatarUpload);
    },

    async navigationBarImageSelected() {
      let avatarUpload = this.$refs.navigationBarLogoUpload;
      await this.imageSelected(avatarUpload);
    },

    async deleteLoginPageImage() {
      await Rpc.OrganizationSetup.deleteLoginPageImage();
    },

    async deleteNavigationBarImage() {
      await Rpc.OrganizationSetup.deleteNavigationBarImage();
      EventBus.$emit(Events.organizationLogoChanged);
    },

    setLoginPageImageAsNull() {
      this.organizationForm.loginPageImage.value = null;
      this.isLoginPageImageDeleted = true;
    },

    setNavigationBarImageAsNull() {
      this.organizationForm.navigationBarImage.value = null;
      this.isNavigationBarImageDeleted = true;
    }

  },

  props: {
    activeBranding: {type: Boolean, default: true},
  },

  data: () => ({
    domain: new Domain(),
    organizationForm: new OrganizationForm(),
    domainForm: new ValidatedField(null, "", Rpc.Validators.validateDomainText).withLabel($tr("domain","Domain")),
    permissions: new PermissionsSet(),
    isNavigationBarImageDeleted: false,
    isLoginPageImageDeleted: false,
    iconStatusLabel: "",
    buttonStatus: "Bind",
    statusOfVerification: "not verified",
    verificationError: "",
    readOnlyInputs: true,
    readOnlyInputsSettings: false,
    changedOrganizationPicture: false,
  })
}
</script>
